export const dynamicSource = {
  balanceType: [{
    value: 10010, label: '全费出单'}, {
    value: 10020, label: '净费出单'}, {
    value: 10030, label: '未知'}, {
  }],
  insuranceType: [{
    value: 10, label: '商业险'}, {
    value: 11, label: '交强险'}, {
    value: 20, label: '非车险'
  }],
  dynamicPolicyStatus: [{
    value: 1, label: '有效'}, {
    value: 2, label: '无效'
  }]
}

export default {
  dynamicSource
}



// WEBPACK FOOTER //
// ./src/data/dynamicSource.js